import { render, staticRenderFns } from "./DeliveryCapabilityView.vue?vue&type=template&id=6c7a0e1d&scoped=true"
import script from "./DeliveryCapabilityView.vue?vue&type=script&lang=js"
export * from "./DeliveryCapabilityView.vue?vue&type=script&lang=js"
import style0 from "./DeliveryCapabilityView.vue?vue&type=style&index=0&id=6c7a0e1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7a0e1d",
  null
  
)

export default component.exports